import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";
import onObjectLocationReportedEventAction from "../actions/on-object-location-reported-event.action";
import { mapObjectToMarker } from "domain/objects/entities/mappers/map-object-to-marker.mapper";

const onObjectLocationReportedEventCases = (
  builder: ActionReducerMapBuilder<ObjectsState>
) => {
  builder.addCase(
    onObjectLocationReportedEventAction.fulfilled,
    (state, action) => {
      const newObject = action.payload;

      if (newObject) {
        const objectIndex = state.objects.findIndex(
          (o) => o.uniqueId === newObject.uniqueId
        );
        if (objectIndex !== -1) {
          state.objects[objectIndex] = {
            ...state.objects[objectIndex],
            ...newObject
          };
        }

        if (state.selectedObject?.uniqueId === newObject.uniqueId) {
          state.selectedObject = newObject;
        }

        if (state.markers.length > 0) {
          const newMarker = mapObjectToMarker(newObject);

          const makerIndex = state.markers.findIndex(
            (m) => m.uniqueId === newObject.uniqueId
          );
          if (makerIndex !== -1) {
            state.markers[makerIndex] = {
              ...state.markers[makerIndex],
              ...newMarker
            };
          }
        }
      }
    }
  );
};

export default onObjectLocationReportedEventCases;
